import React from 'react';
import { Flex } from '@adobe/react-spectrum';
import { getActiveTool, getSelection } from 'app/stores/selectors';
import { Divider } from 'app/views/components/editor/sidebar/Divider';
import { ArrowDefaultsPicker } from 'app/views/components/editor/sidebar/tools/ArrowTypePicker';
import { BlurDefaultsPicker } from 'app/views/components/editor/sidebar/tools/BlurMethodPicker';
import { FontDefaultsPicker } from 'app/views/components/editor/sidebar/tools/FontPicker';
import { SpotDefaultsPicker } from 'app/views/components/editor/sidebar/tools/SpotTypePicker';
import { useConnect } from 'app/views/hooks/useConnect';
import { ZoomDefaultsPicker } from './tools/ZoomTypePicker';
const Map = {
    text: FontDefaultsPicker,
    cloud: FontDefaultsPicker,
    spot: SpotDefaultsPicker,
    arrow: ArrowDefaultsPicker,
    blur: BlurDefaultsPicker,
    zoom: ZoomDefaultsPicker,
};
export const Insertion = (props) => {
    const { direction = 'column' } = props;
    const { hasSelection, activeTool } = useConnect(state => ({
        hasSelection: getSelection(state).length > 0,
        activeTool: getActiveTool(state),
    }));
    if (hasSelection || !activeTool) {
        return null;
    }
    const Component = Map[activeTool.id];
    if (!Component) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Divider, null),
        React.createElement(Flex, { direction: direction },
            React.createElement(Component, { toolId: activeTool.id }))));
};
